// extracted by mini-css-extract-plugin
export default {"iFrame":"iframe__iFrame__lr7LU"};